import { createI18n } from 'vue-i18n';
import en from './en/messages';
import fr from './fr/messages';

const locale = window.config?.locale || 'en';

const i18n = createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'en',
    missingWarn: false,
    fallbackWarn: false,
    messages: { en, fr }
});

export default i18n;
